import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { WeightMeasurement, WeightMeasurementsFetchParams } from '~/interfaces/babyGrowth'
import { fetchBabyGrowthWeightMeasurements, message } from '~/services'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'babyGrowthWeightMeasurements'

export const useFetchBabyGrowthWeightMeasurements = (
  params: WeightMeasurementsFetchParams
): UseQueryResult<WeightMeasurement[], Error> => {
  const fetcher = async (): Promise<WeightMeasurement[]> => {
    try {
      return await fetchBabyGrowthWeightMeasurements(params)
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  const hasParams = (): boolean => hasObjectValue({ params })

  return useQuery<WeightMeasurement[], Error>([UNIQUE_KEY, params], async () => await fetcher(), {
    enabled: hasParams(),
    cacheTime: Infinity,
    staleTime: Infinity
  })
}
